module.exports = __webpack_public_path__ + "static/img/AFSTEREO.2ace1fe.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/AFSTEREO.PNG
// module id = 2828
// module chunks = 3